import PropTypes from 'prop-types';
import * as React from "react"
const LogoVisa = ({ desc, descId, title = 'Visa logo', titleId, ...props }) => (
  <svg
  aria-describedby={descId}
    aria-labelledby={titleId}
    viewBox="0 0 81 27"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
  
    <g fill="none" fillRule="evenodd">
      <path d="M-12-22H98v70H-12z" fill="none" />
      <path
        d="m39.979.737-5.36 25.74h-6.48L33.498.737h6.48Zm27.267 16.62 3.412-9.666 1.962 9.667h-5.374Zm7.234 9.12h5.993L75.237.737H69.71c-1.246 0-2.296.743-2.761 1.887l-9.725 23.853h6.806l1.352-3.844h8.314l.785 3.844Zm-16.92-8.404c.029-6.792-9.14-7.17-9.078-10.204.02-.922.876-1.905 2.748-2.156.928-.123 3.489-.222 6.392 1.152l1.135-5.46C57.197.824 55.191.266 52.695.266c-6.407 0-10.915 3.497-10.95 8.508-.041 3.706 3.22 5.772 5.67 7.006 2.528 1.261 3.376 2.07 3.363 3.198-.017 1.726-2.016 2.49-3.876 2.52-3.26.052-5.15-.906-6.656-1.627l-1.176 5.643c1.516.713 4.31 1.334 7.205 1.366 6.811 0 11.265-3.456 11.285-8.808ZM30.718.737l-10.502 25.74h-6.85L8.198 5.935c-.313-1.264-.587-1.728-1.54-2.261C5.1 2.804 2.528 1.99.266 1.484L.418.737h11.029c1.404 0 2.668.96 2.99 2.623l2.73 14.896L23.908.737h6.809Z"
        fill="#1A1F71"
        fillRule="nonzero"
      />
    </g>
  </svg>
)
export default LogoVisa


LogoVisa.propTypes = {
	desc: PropTypes.string,
    descId: PropTypes.string,
    title: PropTypes.string,
    titleId: PropTypes.string,
};